export default {
  title: "Административная панель | Radiogram",
  profile: "Профиль",
  settings: "Настройки",
  "settings.photo": "Фотография",
  "settings.changePassword": "Смена пароля",
  "settings.changePassword.newPassword": "Новый пароль",
  "settings.changePassword.repeatPassword": "Повторите ввод",
  "settings.changePassword.submit": "Изменить",
  "settings.changePassword.success": "Пароль успешно изменен",
  "settings.changePassword.error": "Ошибка изменения пароля",
  "settings.photo.upload": "Загрузить",

  Dashboard: "Отчеты",
  "Dashboard.date": "Дата",
  "Dashboard.value": "Значение",

  TimeScales: "Период",
  "TimeScales.day": "День",
  "TimeScales.week": "Неделя",
  "TimeScales.month": "Месяц",
  "TimeScales.year": "Год",

  "Dashboard.Categories.Summary": "Сводка по категориям",
  "Dashboard.Categories.Dynamic": "Динамика по категориям",
  "Dashboard.Categories.MessagesStats": "Количество прослушиваний сообщений",
  "Dashboard.Categories.MessagesDynamic": "Динамика прослушиваний сообщений",
  "Dashboard.Categories.AdvertsStats": "Количество прослушиваний рекламы",
  "Dashboard.Categories.AdvertsDynamic": "Динамика прослушиваний рекламы",
  "Dashboard.Categories.CharsSummary": "Сводка по символам",
  "Dashboard.Categories.CharsDynamic": "Динамика по символам",

  "Dashboard.Messages.Summary": "Сводка по прослушиваниям",
  "Dashboard.Messages.Dynamic": "Динамика прослушиваний",

  "Dashboard.Activity.Retention": "RR",

  "Dashboard.Adverts.Summary": "Сводка по объявлениям",
  "Dashboard.Adverts.Dynamic": "Динамика объявлений",

  "Dashboard.Chars.Summary": "Сводка преобразований",
  "Dashboard.Chars.Dynamic": "Динамика преобразований",

  "Dashboard.ItemsCategories": "Категории",
  "Dashboard.Items.UsersSummary": "Владельцы",
  "Dashboard.Users.Dynamic": "Регистрации",
  "Dashboard.ItemsCategories.Dynamic": "Динамика активаций",
  "Dashboard.Partners.DynamicGender": "Регистрации по полу",
  "Dashboard.Partners.DynamicZodiac": "Регистрации по знакам",
  "Dashboard.Partners.SummaryGender": "Пол",
  "Dashboard.Partners.SummaryAge": "Возраст",
  "Dashboard.Partners.ScoresSummary": "Оценки",
  "Dashboard.Partners.SummaryZodiac": "Пользователи по знакам",

  "Dashboard.Products": "Cклад",
  "Dashboard.Payments.Dynamic": "Динамика платежей",
  "Dashboard.Payments.Summary": "Сводка платежей",
  "Dashboard.Payments.CurrencySummary": "Доходы {currencyName}",
  "Dashboard.Payments.CurrencySummary.ItemsCategories": "Цифровые игрушки",
  "Dashboard.Orders": "Заказы",
  "Dashboard.Orders.Count": "Количество заказов",
  "Dashboard.Orders.Total": "Деньги с заказов",
  "Dashboard.Payouts": "Выплаты",
  "Dashboard.Products.Dynamic": "Динамика склада",

  "Dashboard.KPI": "KPI",
  "Dashboard.KPI.newCount": "Новые",
  "Dashboard.KPI.notNewCount": "Повторные",

  "Dashboard.Payments": "Деньги",
  "Dashboard.Payments.payouts": "Фонды",
  "Dashboard.Payments.commission": "Комиссия",
  "Dashboard.Payments.waitForPayouts": "Не распределены",

  CastsTranslations: "Трансляции выпусков",
  "CastsTranslations.Info": "Информация",
  "CastsTranslations.Form": "Редактировать",
  "CastsTranslations.name": "Название",
  "CastsTranslations.time": "Время трансляции",
  "CastsTranslations.rtmps": "Публикация",
  "CastsTranslations.serverUrl": "Сервер трансляции",
  "CastsTranslations.translationKey": "Ключ трансляции",
  "CastsTranslations.videoFileId": "Видео-файл",

  // перевода для интерфейсов управления учетными записями
  Accounts: "Учетные записи",
  OpenAI: "Редакция",
  "OpenAI.Completions": "Обработчики",
  "OpenAI.Completions.Info": "Информация",
  "OpenAI.Completions.Form": "Редактировать",
  "OpenAI.Completions.name": "Название",
  "OpenAI.Completions.attrs": "Извлекаемые атрибуты",
  "OpenAI.Completions.type": "Тип обработчика",
  "OpenAI.Completions.type.scoring": "Оценка сообщения",
  "OpenAI.Completions.type.convert": "Конвертация",
  "OpenAI.Completions.instructions": "Инструкции",
  "OpenAI.Completions.categories": "Категории",

  "OpenAI.Assistants": "Ассистенты",
  "OpenAI.Assistants.Info": "Информация",
  "OpenAI.Assistants.Form": "Редактировать",
  "OpenAI.Assistants.name": "Название",
  // "OpenAI.Assistants.autoRun": "Автозапуск",
  // "OpenAI.Assistants.TimerRuns": "Запуск по таймеру",
  // "OpenAI.Assistants.TimerRuns.categories": "Категории",
  // "OpenAI.Assistants.TimerRuns.runtime": "Время запуска",
  // "OpenAI.Assistants.Criterias": "Критерии",
  // "OpenAI.Assistants.Criterias.attrName": "Атрибут",
  // "OpenAI.Assistants.Criterias.valueBoolean": "Да/нет",
  // "OpenAI.Assistants.approveCriterias": "Критерии одобрения",
  // "OpenAI.Assistants.rejectCriterias": "Критерии отказа",
  // "OpenAI.Assistants.PostProcessing": "Пост-обработка",
  // "OpenAI.Assistants.PostProcessing.schemaName": "Схема",
  // "OpenAI.Assistants.PostProcessing.schemaMethod": "Метод",
  // "OpenAI.Assistants.ModifyAttrs": "Модификаторы",
  // "OpenAI.Assistants.ModifyAttrs.attrName": "Атрибут",
  // "OpenAI.Assistants.ModifyAttrs.schemaName": "Схема",
  // "OpenAI.Assistants.ModifyAttrs.schemaMethod": "Метод",

  "OpenAI.Assistants.instructions": "Инструкции",
  "OpenAI.Assistants.openAIId": "OpenAI ID",
  "OpenAI.Assistants.saveDate": "Дата сохранения",
  "OpenAI.Assistants.syncDate": "Дата синхронизации",
  "OpenAI.Assistants.batchSize": "Размер пакета обработки",
  "OpenAI.Assistants.temperature": "Температура",
  "OpenAI.Assistants.top_p": "Top P",
  "OpenAI.Assistants.Sync": "Синхронизировать",

  "OpenAI.Casts": "Выпуски",
  "OpenAI.Casts.compile": "Компиляция",
  "OpenAI.Casts.title": "Заголовок",
  "OpenAI.Casts.category": "Категория",
  "OpenAI.Casts.channel": "Канал",
  "OpenAI.Casts.status": "Статус",
  "OpenAI.Casts.status.new": "Новый",
  "OpenAI.Casts.status.new.style": "primary",
  "OpenAI.Casts.status.progress": "В обработке",
  "OpenAI.Casts.status.progress.style": "info",
  "OpenAI.Casts.status.completed": "Модерация",
  "OpenAI.Casts.status.completed.style": "danger",
  "OpenAI.Casts.status.published": "Опубликован",
  "OpenAI.Casts.status.published.style": "success",
  "OpenAI.Casts.status.rejected": "Отклонен",
  "OpenAI.Casts.status.rejected.style": "danger",
  "OpenAI.Casts.status.error": "Ошибка",
  "OpenAI.Casts.status.error.style": "danger",
  "OpenAI.Casts.isLast": "Последний",
  "OpenAI.Casts.approve": "Опубликовать",
  "OpenAI.Casts.completedAt": "Завершено",
  "OpenAI.Casts.publishedAt": "Опубликовано",
  "OpenAI.Casts.reject": "Отклонить",
  "OpenAI.Casts.cancel": "Отменить",
  "OpenAI.Casts.restore": "Восстановить",
  "OpenAI.Casts.threadLogs": "Логи генерации",
  "OpenAI.Casts.restartsCount": "Количество перезапусков",
  "OpenAI.Casts.scoringText": "Текст для оценки публикации",
  "OpenAI.Casts.setScoringText": "Сохранить текст",
  "OpenAI.Casts.refreshIntro": "Обновить трейлер",
  "OpenAI.Casts.refreshCover": "Обновить картинку",
  "OpenAI.Casts.refreshCoverPrompt": "Введите prompt для генерации",

  "OpenAI.Schedules": "Расписание",
  "OpenAI.Schedules.assistant": "Ассистент",
  "OpenAI.Schedules.forCategories": "Для категорий",
  "OpenAI.CastsConcat": "Объединение выпусков",
  "OpenAI.Schedules.channels": "Каналы",
  "OpenAI.Schedules.channel": "Канал",
  "OpenAI.Schedules.category": "Категория",

  "OpenAI.Schedules.runtime": "Время запуска",
  "OpenAI.Schedules.runtime.time": "Время",
  "OpenAI.Schedules.runtime.timeTitle": "Подпись времени",
  "OpenAI.Schedules.runtime.periodTitle": "Периодичность",
  "OpenAI.Schedules.runtime.periodPostTitle": "Периодичность в пост",
  "OpenAI.Schedules.runtime.castTitle": "Название выпуска",
  "OpenAI.Schedules.runtime.title": "Заголовок",
  "OpenAI.Schedules.runtime.fileId": "Mp3",
  "OpenAI.Schedules.runtime.includePrevious": "Включая предыдущий выпуск",
  "OpenAI.Schedules.runtime.metaTemplateFileId": "Шаблон обложки в мета-атрибуты",
  "OpenAI.Schedules.runtime.templateFileId": "Шаблон обложки",

  "OpenAI.Schedules.runtime.telegramTextPublish": "Формат публикации в телеграме",
  "OpenAI.Schedules.runtime.telegramTextPublish.audio": "Аудио сообщения",
  "OpenAI.Schedules.runtime.telegramTextPublish.text": "Текст с картинкой",

  "OpenAI.Schedules.runtime.telegramMakeStory": "Делать сториз?",
  "OpenAI.Schedules.runtime.templateStoryFileId": "Шаблон для сториз",
  "OpenAI.Schedules.runtime.templatePostFileId": "Шаблон для поста",

  "OpenAI.Schedules.runtime.telegramPublish": "Публикация выпуска в телеграме",
  "OpenAI.Schedules.runtime.telegramCollapse": "Публикация всех выпусков в одном сообщении",

  "OpenAI.Schedules.name": "Название",
  "OpenAI.Schedules.dailySum": "Главное за день",
  "OpenAI.Schedules.dailySumAmount":
    "Количество сообщений из каждого выпуска для подборки 'Главное за день'",
  "OpenAI.Schedules.currentDayMessagesOnly": "Сообщения только за сегодня",
  "OpenAI.Schedules.everyDay": "Каждый день?",
  "OpenAI.Schedules.defaultTitle": "Заголовок по умолчанию",
  "OpenAI.Schedules.specificWeekDays": "По дням недели",
  "OpenAI.Schedules.specificMonthDays": "По дням месяца",
  "OpenAI.Schedules.timeShift": "Максимальное временное окно для сообщений",
  "OpenAI.Schedules.timeShiftValue": "Значение",
  "OpenAI.Schedules.timeShiftScale": "Интервал",
  "OpenAI.Schedules.categories": "Категории",
  "OpenAI.Schedules.showOnWebsite": "Показывать на сайте",
  "OpenAI.Schedules.orderByScore": "Ранжировать сообщения по оценке",
  "OpenAI.Schedules.imageGeneration": "Генерировать обложку?",
  "OpenAI.Schedules.imageGenerationInstructions": "Инструкции для генерации обложки",
  "OpenAI.Schedules.restartsLimit": "Количество допустимых перезапусков",
  "OpenAI.Schedules.minScore": "Минимальная оценка сообщений",
  "OpenAI.Schedules.publicationsMinCount": "Минимальное количество сообщений в выпуске",
  "OpenAI.Schedules.autoPublish": "Автоматическая публикация выпуска",
  "OpenAI.Schedules.autoPublish.short": "Автопубликация",

  "OpenAI.Schedules.Form": "Редактировать",
  "OpenAI.Schedules.Info": "Информация",
  "OpenAI.Schedules.Add": "Добавить расписание",
  "OpenAI.Schedules.Generations": "Генерации",
  "OpenAI.Schedules.Add": "Добавить расписание",

  "OpenAI.Threads": "Треды",
  "OpenAI.Threads.openAIId": "OpenAI ID",
  "OpenAI.Threads.category": "Категория",
  "OpenAI.Threads.lastMessageDate": "Последнее сообщение",
  "OpenAI.Threads.lastRunDate": "Последняя обработка",
  "OpenAI.Runs": "Обработки",
  "OpenAI.Runs.openAIId": "OpenAI ID",
  "OpenAI.Runs.startDate": "Дата запуска",
  "OpenAI.Runs.finishDate": "Дата окончания",

  telegramPublishChannel: "Публиковать в канал",

  telegramPublishFormat: "Формат публикации в телеграме",
  "telegramPublishFormat.text": "Текст с картинкой",
  "telegramPublishFormat.audio": "Аудио",
  "telegramPublishFormat.video": "Видео",
  "telegramPublishFormat.trailer": "Трейлер",
  "telegramPublishFormat.text_audio_separated": "Текст и каждый аудио-файл отдельно",
  "telegramPublishFormat.text_audio_combined": "Текст и аудио-файлы вместе",

  // перевода для интерфейсов управления пользователями
  Users: "Пользователи",
  "Users.Add": "Добавить пользователя",
  "Users.Info": "Информация",
  "Users.Data": "Данные",
  "Users.User": "Данные пользователя",
  "Users.User.Save": "Редактировать пользователя",
  "Users.Form.changePhone": "Изменить номер телефона",
  "Users.isAdmin": "Админ",
  "Users.itemsCount": "Покупки",
  "Users.ident": "ID",
  "Users.login": "Логин",
  "Users.name": "Имя",
  "Users.email": "Email",
  "Users.phone": "Номер телефона",
  "Users.password": "Пароль",
  "Users.access": "Права доступа",
  "Users.add": "Добавить",
  "Users.login-busy": "Логин занят",
  "Users.table.login": "Логин",
  "Users.table.name": "Имя",

  Logins: "Данные для авторизации",
  "Logins.Add": "Добавить логин",
  "Logins.Edit": "Изменить логин",
  "Logins.value": "Логин",
  "Logins.type": "Тип",
  "Logins.type.plain": "Обычный",
  "Logins.type.phone": "Телефон",
  "Logins.type.email": "Email",
  "Logins.type.telegram": "Telegram",
  "Logins.type.max": "Max",

  Accesses: "Права доступа",
  "Accesses.Add": "Добавить право доступа",
  "Accesses.Form": "Редактировать права доступа",
  "Accesses.title": "Название",
  "Accesses.components": "Компоненты",

  Catalogs: "Настройки",

  Telegram: "Телеграм",
  "Telegram.Accounts": "Учетные записи",
  "Telegram.Accounts.isOnline": "Онлайн",
  "Telegram.Accounts.isBot": "Это бот?",
  "Telegram.Accounts.token": "Токен",
  "Telegram.Accounts.apiId": "API Id",
  "Telegram.Accounts.apiHash": "API Hash",

  Partners: "Админы",
  "Partners.Add": "Добавить админ",
  "Partners.Form": "Редактировать данные админа",
  "Partners.Info": "Информация",
  "Partners.Users": "Аккаунты",
  "Partners.Users.account": "Аккаунт",
  "Partners.Users.access": "Права доступа",
  "Partners.Data": "Данные админа",
  "Partners.name": "Название",
  "Partners.channelsCount": "Кол-во каналов",
  "Partners.ident": "ID",

  Replacements: "Замены",
  "Replacements.Add": "Добавить замену",
  "Replacements.Form": "Редактировать замену",
  "Replacements.Info": "Информация",
  "Replacements.originValue": "Исходное значение",
  "Replacements.targetValue": "Замена",

  StopWords: "Стоп-слова",
  "StopWords.Add": "Добавить стоп-слово",
  "StopWords.Form": "Редактировать стоп-слово",
  "StopWords.Info": "Информация",
  "StopWords.value": "Значение",

  FilterWords: "Фильтр-слова",
  "FilterWords.Add": "Добавить фильтр-слово",
  "FilterWords.Form": "Редактировать фильтр-слово",
  "FilterWords.Info": "Информация",
  "FilterWords.value": "Значение",

  ImageStyles: "Стили обложек",
  "ImageStyles.Add": "Добавить стиль",
  "ImageStyles.Form": "Редактировать стиль",
  "ImageStyles.Info": "Информация",
  "ImageStyles.name": "Название",
  "ImageStyles.text": "Инструкции",

  Listeners: "Слушатели",
  "Listeners.sessionId": "Слушатель",
  "Listeners.firstDate": "Первая дата",
  "Listeners.lastDate": "Последняя дата",
  "Listeners.dataCount": "Прослушивания",
  "Listeners.activityDaysCount": "Дни",
  "Listeners.progressListening": "Дослушивания, %",
  "Listeners.progressTime": "Время",

  Channels: "Каналы",
  "Channels.Add": "Добавить канал",
  "Channels.Order": "Сортировать каналы",
  "Channels.Form": "Редактировать данные",
  "Channels.Info": "Информация",
  "Channels.Stats": "Статистика",
  "Channels.Messages": "Сообщения",
  "Channels.Messages.url": "Ссылка на сообщение",
  "Channels.name": "Название",
  "Channels.searchName": "Название для поиска",
  "Channels.castsSchedules": "Частотность выпусков",
  "Channels.imagePrompt": "Промпт для картинок по умолчанию",
  "Channels.soundName": "Ролик",
  "Channels.introSoundMessage": "Вступительное сообщение",
  "Channels.soundFileId": "Файл",
  "Channels.alias": "Ссылка",
  "Channels.description": "Описание",
  "Channels.category": "Категория",
  "Channels.admin": "Админ",
  "Channels.voice": "Используемый голос",
  "Channels.tariff": "Тариф",
  "Channels.specialTariff": "Специальные тарифные условия",
  "Channels.hideRecommendaton": "Скрыть рекомендации",
  "Channels.approveMessages": "Принимать все сообщения",
  "Channels.playlistDefault": "Лучшее",
  "Channels.playlistCategory": "В плейлисте",
  "Channels.file": "Лого",
  "Channels.metaTemplateFileId": "Шаблон для обложки выпусков в мета-атрибутах",
  "Channels.templateFileId": "Шаблон обложки",
  "Channels.templateStoryFileId": "Шаблон для сториз",
  "Channels.rejectCasts": "Отменить выпуски",
  "Channels.Settings": "Настройки",
  "Channels.Settings.excludeStrings": "Исключения",
  "Channels.Settings.stopWords": "Стоп-слова",
  "Channels.Settings.keepHashtags": "Сохранять хештеги",

  "Channels.Translations": "Трансляции каналов",
  "Channels.Translations.Form": "Редактировать",
  "Channels.Translations.Logs": "История запусков",
  "Channels.Translations.Logs.messagesCount": "Кол-во сообщений",
  "Channels.Translations.Logs.duration": "Продолжительность",
  "Channels.Translations.Logs.completedAt": "Дата готовности",
  "Channels.Translations.Logs.finishedAt": "Дата завершения",
  "Channels.Translations.channel": "Канал",
  "Channels.Translations.dataNode": "Нода",
  "Channels.Translations.rtmps": "Настройки вещания",
  "Channels.Translations.serverUrl": "Адрес трансляции",
  "Channels.Translations.params": "Параметры",
  "Channels.Translations.params.minScore": "Минимальная оценка",
  "Channels.Translations.params.lastHours": "За прошедшее время в часах",
  "Channels.Translations.fileId": "Шаблон-изображение",
  "Channels.Translations.videoFileId": "Видео-шаблон",

  DataNodes: "Ноды данных",
  "DataNodes.ident": "Ident",
  "DataNodes.ip": "IP",
  "DataNodes.lastOnline": "Онлайн",

  Premiums: "Премиумы",
  "Premiums.Add": "Добавить премиум",
  "Premiums.Form": "Редактировать данные",
  "Premiums.Info": "Информация",
  "Premiums.name": "Название",
  "Premiums.duration": "Длительность, месяцы",
  "Premiums.prices": "Цены",

  Tariffs: "Тарифы",
  "Tariffs.Add": "Добавить тариф",
  "Tariffs.Form": "Редактировать данные",
  "Tariffs.Info": "Информация",
  "Tariffs.name": "Название",
  "Tariffs.description": "Описание",
  "Tariffs.duration": "Длительность, месяцы",
  "Tariffs.prices": "Цены",

  Messages: "Сообщения",
  "Messages.Add": "Добавить сообщение",
  "Messages.Form": "Редактировать данные",
  "Messages.Info": "Информация",
  "Messages.ident": "Код",
  "Messages.text": "Текст",
  "Messages.title": "Заголовок",
  "Messages.date": "Дата",
  "Messages.score": "Оценка",
  "Messages.mp3": "mp3",
  "Messages.status": "Статус",
  "Messages.duration": "Длительность",
  "Messages.prices": "Цены",
  "Messages.channel": "Канал",

  // заказы
  Orders: "Заказы",
  "Orders.Order": "Данные заказа",
  "Orders.info": "Информация",
  "Orders.ident": "ID",
  "Orders.costs": "Цена",
  "Orders.customer": "Клиент",
  "Orders.partner": "Партнер",
  "Orders.payout": "Выплата",
  "Orders.treeCost": "Цена",
  "Orders.commission": "Комиссия",

  Sounds: "Звуки",
  "Sounds.Settings": "Настройки",
  "Sounds.Settings.jingleFileId": "Джингл",
  "Sounds.Settings.textToSpeechModel": "Голосовая модель",
  "Sounds.Settings.ttsHD": "HD качество",
  "Sounds.Settings.textSpeed": "Скорость речи, %",
  "Sounds.Settings.castsTariffsIds": "Требуемые тарифы для выпусков каналов",
  "Sounds.Settings.translationsTariffsIds": "Требуемые тарифы для трансляций каналов",
  "Sounds.Settings.translationTextSpeed": "Скорость речи в трансляции, %",
  "Sounds.Settings.textInstructions": "Инструкции к тексту (выразительно, плавно, внятно, и т.д)",
  "Sounds.Settings.test": "Протестировать голос (перед тестом нужно сохранить изменения)",
  "Sounds.Backgrounds": "Фоновые звуки",
  "Sounds.Backgrounds.name": "Название",
  "Sounds.Backgrounds.originFileId": "Исходный файл",
  "Sounds.Backgrounds.volume": "Громкость, %",
  "Sounds.Backgrounds.volumeFileId": "Файл с установленной громкостью",

  "Sounds.Voices": "Голоса",
  "Sounds.Voices.Form": "Редактировать",
  "Sounds.Voices.name": "Название",
  "Sounds.Voices.service": "Сервис",
  "Sounds.Voices.voice": "Голос",
  "Sounds.Voices.model": "Модель",
  "Sounds.Voices.instructions": "Инструкции",
  "Sounds.Voices.isDefault": "Голос по умолчанию",
  "Sounds.Voices.isService": "Служебный",
  "Sounds.Voices.speed": "Скорость речи, %",
  "Sounds.Voices.sampleFile": "Пример звучания",
  "Sounds.Voices.sampleText": "Текст для проверки звучания",
  "Sounds.Voices.makeSample": "Сгенерировать пример",

  "Sounds.Compiler": "Сборщик",
  "Sounds.Compiler.mp3": "mp3",
  "Sounds.Compiler.image": "Картинка",
  "Sounds.Compiler.title": "Заголовок",
  "Sounds.Compiler.author": "Исполнитель",
  "Sounds.Compiler.submit": "Отправить",

  Payments: "Транзакции",
  "Payments.value": "Сумма",
  "Payments.reference": "Тип",
  "Payments.currency": "Валюта",
  "Payments.customer": "Клиент",
  "Payments.status": "Статус",
  "Payments.status.new": "Новая",
  "Payments.status.wait_payment": "Ожидает оплаты",
  "Payments.status.paid": "Оплачена",
  "Payments.status.error": "Ошибка",
  "Payments.status.declined": "Отменена",

  "Payments.Settings": "Настройки",
  "Payments.Settings.textToSpeechCost": "Стоимость обработки",
  "Payments.Settings.textToSpeechCharsAmount": "За количество символов",
  "Payments.Settings.textToSpeechModel": "Модель",
  "Payments.Settings.textToSpeechCurrencyId": "Валюта за обработку",
  "Payments.Settings.defaultAccountAdminId": "Админ для каналов по умолчанию",

  "Payments.TelegramExtensions": "Расширения телеграм",
  "Payments.TelegramExtensions.token": "Токен",

  "Payments.Transactions": "Платежи",
  "Payments.Receipts": "Чеки",
  "Payments.ReceiptsServices": "Чековые сервисы",
  "Payments.PaymentsServices": "Платежные сервисы",

  "Payments.Currency": "Валюта",
  "Payments.Currencies": "Валюты",
  "Payments.Currencies.marketplaces": "Используется на площадках",
  "Payments.Currencies.isoName": "ISO4217 название",
  "Payments.Currencies.isoCode": "ISO4217 цифровой код",

  PublishChannels: "Каналы для публикаций",
  "PublishChannels.name": "Название",
  "PublishChannels.alias": "Alias",
  "PublishChannels.accountId": "Аккаунт для публикации",

  Countries: "Страны",
  "Countries.code": "Код",
  "Countries.currency": "Валюта",
  "Countries.isDefault": "По умолчанию",

  Receipts: "Чеки",
  "Receipts.Receipt": "Чек",
  "Receipts.type": "Тип",
  [`Receipts.type.buy_tree`]: "Покупка дерева",

  "Receipts.customer": "Клиент",
  "Receipts.status": "Статус",
  [`Receipts.status.new`]: "Новый",
  [`Receipts.status.new.style`]: "secondary",
  [`Receipts.status.ready`]: "Готов к обработке",
  [`Receipts.status.ready.style`]: "secondary",
  [`Receipts.status.process`]: "В обработке",
  [`Receipts.status.process.style`]: "secondary",
  [`Receipts.status.success`]: "Завершен",
  [`Receipts.status.success.style`]: "success",
  [`Receipts.status.error`]: "Ошибка",
  [`Receipts.status.error.style`]: "danger",

  Genders: "Пол",
  "Genders.male": "Мужской",
  "Genders.female": "Женский",
  "Genders.null": "Неизвестно",

  Locales: "Локализации",
  "Locales.Locale": "Язык",
  "Locales.icon": "Иконка",
  "Locales.code": "Код",
  "Locales.isDefault": "Язык по умолчанию",
  "Locales.ru": "Русский",
  "Locales.en": "English",

  Marketplaces: "Торговые площадки",
  "Marketplaces.bgColor": "Цвет фона",
  "Marketplaces.fontColor": "Цвет шрифта",
  "Marketplaces.logo": "Логотип",
  "Marketplaces.url": "Ссылка",

  Rewards: "Награды и предметы",
  "Rewards.file": "Файл",
  "Rewards.symbol": "Символ",
  "Rewards.type": "Тип",
  "Rewards.expKoef": "Коэффициент",
  "Rewards.values": "Значения",

  Reactions: "Реакции",
  "Reactions.references": "Доступно для элементов",
  "Reactions.rewardsValues": "Выдаваемые награды",

  DailyCover: "Ежедневная обложка",
  DailyCoversPrompts: "Ежедневные обложки",
  "DailyCoversPrompts.Form": "Редактировать",

  DateTimeGroups: "Масштаб времени",
  "DateTimeGroups.now": "Сейчас",
  "DateTimeGroups.toStartOfHour": "По часам",
  "DateTimeGroups.toStartOfDay": "По дням",
  "DateTimeGroups.toStartOfWeek": "По неделям",
  "DateTimeGroups.toStartOfMonth": "По месяцам",
  "DateTimeGroups.toStartOfYear": "По годам",

  PaymentsServicesTypes: "Платежный сервис",
  "PaymentsServicesTypes.yoo_kassa": "Ю-Касса",
  "PaymentsServicesTypes.tinkoff_kassa": "Тинькофф-Касса",
  "PaymentsServicesTypes.stripe": "Stripe",
  "PaymentsServicesTypes.telegram": "Telegram",

  ReceiptsServicesTypes: "Кассовый сервис",
  "ReceiptsServicesTypes.cloud_kassir": "Cloud Kassir",
  "ReceiptsServicesTypes.kit_online": "KIT online",

  AstroSigns: "Знаки зодиака",
  "AstroSigns.aries": "Овен",
  "AstroSigns.taurus": "Телец",
  "AstroSigns.gemini": "Близнецы",
  "AstroSigns.cancer": "Рак",
  "AstroSigns.leo": "Лев",
  "AstroSigns.virgo": "Дева",
  "AstroSigns.libra": "Весы",
  "AstroSigns.scorpio": "Скорпион",
  "AstroSigns.sagittarius": "Стрелец",
  "AstroSigns.capricorn": "Козерог",
  "AstroSigns.aquarius": "Водолей",
  "AstroSigns.pisces": "Рыбы",
  "AstroSigns.null": "Неизвестно",

  Contents: "Справочники",
  "Contents.Add": "Добавить",
  "Contents.Form": "Редактировать",
  "Contents.name": "Название",
  "Contents.value": "Значение",
  "Contents.text": "Текст",
  "Contents.file": "Файл",
  "Contents.tag": "Тег",
  "Contents.icon": "Иконка",
  "Contents.isPaid": "Платный доступ",
  "Contents.category": "Категория",
  "Contents.itemCategory": "Мемстер",
  "Contents.topic": "Тема",

  Adverts: "Реклама",
  "Adverts.Add": "Добавить рекламу",
  "Adverts.name": "Название",
  "Adverts.content": "Ролик",
  "Adverts.url": "Ссылка",
  "Adverts.file": "Файл",
  "Adverts.legalName": "Юр лицо",
  "Adverts.image": "Лого",
  "Adverts.title": "Заголовок",
  "Adverts.Intros": "Вступления",
  "Adverts.Settings": "Настройки",
  "Adverts.Settings.limit": "Количество прослушанных сообщений",
  "Adverts.Settings.offset": "Отступ для рандомного окна (+/-)",
  "Adverts.Settings.maxSeconds": "Количество секунд прослушивания",
  "Adverts.Settings.daysInterval": "Количество дней прослушивания",
  "Adverts.Settings.maxRepeats": "Число повторений рекламы на пользователя",

  Advertisers: "Рекламодатели",
  "Advertisers.Intros": "Вступления",
  "Advertisers.Add": "Добавить рекламодателя",
  "Advertisers.Data": "Данные",
  "Advertisers.Info": "Информация",
  "Advertisers.Adverts": "Ролики",
  "Advertisers.Stats": "Статистика",
  "Advertisers.Companies": "Кампании",
  "Advertisers.Users": "Аккаунты",
  "Advertisers.name": "Название",

  "Companies.Add": "Добавить кампанию",
  "Companies.advert": "Объявление",
  "Companies.name": "Название",
  "Companies.text": "Текст",
  "Companies.mp3": "Ролик",
  "Companies.category": "Категория",
  "Companies.startDate": "Дата запуска",
  "Companies.endDate": "Дата завершения",
  "Companies.totalLimit": "Лимит",
  "Companies.dayLimit": "День",
  "Companies.prices": "Цена за показ",
  "Companies.remainsLimit": "Остаток",
  "Companies.income": "Доход",
  "Companies.statsCount": "Прослушивания",
  "Companies.coverage": "Охват",
  "Companies.totalCost": "Бюджет",
  "Companies.status": "Статус",
  "Companies.status.new": "Черновик",
  "Companies.status.in_progress": "Запущена",
  "Companies.status.paused": "Пауза",
  "Companies.status.completed": "Завершена",

  Items: "Товары",
  "Items.List": "Регистрации",
  "Items.Add": "Добавить товар",

  "Items.Types": "Типы продукции",
  "Items.Types.Add": "Добавить тип",
  "Items.Types.name": "Название",
  "Items.Types.isDigital": "Цифровой",

  "Items.Seasons": "Сезоны продукции",
  "Items.Seasons.Add": "Добавить сезон",
  "Items.Seasons.name": "Название",
  "Items.Seasons.isCurrent": "Текущий",

  Categories: "Категории",
  "Categories.Add": "Добавить категорию",
  "Categories.name": "Название",
  "Categories.tag": "Тег",
  "Categories.country": "Страна",
  "Categories.countryDefault": "По умолчанию в стране",
  "Categories.alias": "Ссылка",
  "Categories.isRegion": "Региональная категория",
  "Categories.description": "Описание",
  "Categories.castsSchedules": "Частность выпусков",
  "Categories.prices": "Цены за показ по умолчанию",
  "Categories.imagePrompt": "Промпт для картинки по умолчанию",
  "Categories.castTitle": "Заголовок для выпусков",
  "Categories.soundText": "Озвучка для выпусков",
  "Categories.soundFileId": "Файл озвучки для выпусков",
  "Categories.metaTemplateFileId": "Шаблон для обложки выпусков в мета-атрибутах",
  "Categories.templateFileId": "Шаблон для выпуска",
  "Categories.templateStoryFileId": "Шаблон для сториз",
  "Categories.imageFileId": "Картинка на сайт",

  "Items.category": "Категория",
  "Items.emit": "Партия",
  "Items.ident": "Код",
  "Items.activateDate": "Дата активации",
  "Items.Emits": "Партии",
  "Items.Emits.Add": "Новая партия",
  "Items.Emits.quantity": "Количество",
  "Items.Emits.comment": "Комментарий",

  Moderation: "Модерация",
  [`Moderation.stats.claims`]: "Жалобы",
  [`Moderation.stats.claims.style`]: "danger",
  [`Moderation.stats.publications`]: "Публикации",
  [`Moderation.stats.publications.style`]: "success",

  Claims: "Жалобы",
  [`Claims.stats.new`]: "Новые",
  [`Claims.stats.new.style`]: "danger",

  "Claims.Details": "Детали",
  "Claims.message": "Жалоба",
  "Claims.user": "Пользователь",
  "Claims.reference": "Сущность",
  "Claims.quantity": "Количество",
  "Claims.status": "Статус",
  "Claims.setClaimed": "Утвердить жалобу",
  "Claims.rejectClaims": "Отклонить жалобы",

  Publications: "Публикации",
  [`Publications.stats.new`]: "Новые",
  [`Publications.stats.new.style`]: "success",

  "Publications.Comments": "Комментарии",
  "Publications.Form": "Редактировать",
  "Publications.attachments": "Приложения",
  "Publications.attachments.references": "Тип",
  "Publications.content": "Сообщение",
  "Publications.localedContent": "Локализованное сообщение",
  "Publications.locale": "Оригинальная локализация",
  "Publications.user": "Пользователь",
  "Publications.publishedAt": "Дата публикации",

  //
  Specials: "Спецвыпуски",
  "Specials.Sources": "Источники",
  "Specials.Prompts": "Промпты",
  "Specials.Selections": "Подборки",
  "Specials.Categories": "Спецкатегории",

  "Specials.Prompts.text": "Текст промпта",

  "Specials.Casts": "Выпуски",
  "Specials.Casts.Add": "Новый выпуск",
  "Specials.Casts.Form": "Редактировать",
  "Specials.Casts.Publish": "Опубликовать",
  "Specials.Casts.category": "Категория",
  "Specials.Casts.rssUrl": "RSS ссылка",
  "Specials.Casts.promptRole": "Роль в промпте",

  "Specials.Casts.channels": "Каналы",
  "Specials.Casts.name": "Название",
  "Specials.Casts.text": "Анонс",
  "Specials.Casts.duration": "Длительность",
  "Specials.Casts.soundNameFileId": "Озвучка названия",
  "Specials.Casts.soundTextFileId": "Озвучка анонса",

  "Specials.Casts.translationPublish": "Добавлять в трансляцию",
  "Specials.Casts.telegramPublish": "Публиковать в телеграм",
  "Specials.Casts.telegramTextPublish": "Формат публикации",
  "Specials.Casts.telegramTextPublish.text": "Текст",
  "Specials.Casts.telegramTextPublish.audio": "Аудио",
  "Specials.Casts.metaTemplateFileId": "Шаблон для обложки выпусков в мета-атрибутах",
  "Specials.Casts.templateFileId": "Шаблон для выпуска",
  "Specials.Casts.telegramStoryPublish": "Делать сториз",
  "Specials.Casts.storyTemplateFileId": "Шаблон для сториз",

  "Specials.Casts.fileId": "Обложка",
  "Specials.Casts.telegramMessageId": "Публикация в телеграм",
  "Specials.Casts.status": "Статус",
  "Specials.Casts.status.draft": "Черновик",
  "Specials.Casts.status.draft.style": "secondary",
  "Specials.Casts.status.in_progress": "Публикуется",
  "Specials.Casts.status.in_progress.style": "warning",
  "Specials.Casts.status.published": "Опубликован",
  "Specials.Casts.status.published.style": "success",
  "Specials.Casts.status.deleted": "Удален",
  "Specials.Casts.status.deleted.style": "danger",

  "Specials.Casts.Messages": "Сообщения",
  "Specials.Casts.Messages.Add": "Добавить сообщение",
  "Specials.Casts.Messages.AddPack": "Добавить пакет сообщений",
  "Specials.Casts.Messages.title": "Заголовок",
  "Specials.Casts.Messages.text": "Текст",
  "Specials.Casts.Messages.fileId": "Озвучка",
  "Specials.Casts.Messages.channel": "Канал",
  "Specials.Casts.Messages.ident": "Код сообщения",

  //
  Www: "Cайт",
  "Www.Settings": "Настройки",
  "Www.Settings.astroWeekCost": "Стоимость покупки прогноза на неделю",
  "Www.Settings.phone": "Номер телефона",
  "Www.Settings.email": "Email",
  "Www.Settings.address": "Адрес",
  "Www.Settings.intro_video": "Вступительное видео (код для вставки)",
  "Www.Settings.whatsapp": "Ссылка в WhatsApp",
  "Www.Settings.instagram": "Ссылка на инстаграм",
  "Www.Settings.facebook": "Ссылка на Фейсбук",
  "Www.Settings.vk": "Ссылка на Вконтакте",
  "Www.Settings.telegram": "Ссылка на Telegram",
  "Www.Settings.webSite": "Веб-сайт",
  "Www.Settings.telegramChannel": "Ссылка на телеграм канал",
  "Www.Settings.telegramBot": "Ссылка на бота телеграм",
  "Www.Settings.telegramBotStartMessage": "Приветственное сообщение бота на команде /start",
  "Www.Settings.telegramBotStartButton": "Сообщение на кнопке в приветственном сообщении бота",
  "Www.Settings.notificationScoreMessage": "Сообщение `Оцените выпуск`",
  "Www.Settings.telegramBotNewUserMessage": "Приветственное сообщение новому пользователю",
  "Www.Settings.telegramBotNewUserButton": "Кнопка на сообщении новому пользователю",
  "Www.Settings.dailySumCastTitle": "Название для выпуска `Главное за день`",
  "Www.Settings.dailySumCastDescription": "Описание для выпуска `Главное за день`",
  "Www.Settings.telegramWebApp": "Ссылка на WebApp в Telegram",
  "Www.Settings.maxWebApp": "Ссылка на WebApp в Max",
  "Www.Settings.telegramAccountId": "Аккаунт публикаций в телеграм канал",
  "Www.Settings.telegramStoriesAccountId": "Аккаунт для публикаций сториз",
  "Www.Settings.telegramSystemNotificationAccountId": "Аккаунт для системных уведомлений",
  "Www.Settings.description": "Описание сервиса",
  "Www.Settings.footerText": "Текст в подвале",
  "Www.Settings.introVideo": "Вступительное видео",
  "Www.Settings.logoFileId": "Логотип",
  "Www.Settings.sendNotificationsTime": "Время отправки уведомлений",
  "Www.Settings.translationFileId": "Картинка для трансляций",
  "Www.Settings.frontendMetaCoverFileId": "Шаблон для обложки в мета-атрибутах",
  "Www.Settings.defaultCoverFileId": "Обложка выпусков по умолчанию",
  "Www.Settings.defaultStoryFileId": "Шаблон для сториз по умолчанию",
  "Www.Settings.dailyNotificationCoverFileId": "Обложка по уведомлений по подпискам",
  "Www.Settings.specialCoverFileId": "Обложка для спец выпусков",
  "Www.Settings.specialStoryFileId": "Обложка для сториз спец выпусков",
  "Www.Settings.channelsTranslationsFileId": "Шаблон для трансляций каналов",
  "Www.Settings.templateButtonId": "Шаблон кнопки для сториз",
  "Www.Settings.telegramBottomText": "Подпись выпуска в телеграм",
  "Www.Settings.allowSelectCountry": "Выбор страны",
  "Www.Settings.versionNumber": "Версия",
  "Www.Settings.minMessageLength": "Минимальная длина сообщений",
  "Www.Settings.playlistText": "Пустой плейлист",
  "Www.Settings.playlistVariants": "Подсказки для плейлиста",
  "Www.Settings.channelsDescription": "Превью каналов",
  "Www.Settings.favoritesDescription": "Описание для избранного",
  "Www.Settings.emptyFavoritesDescription": "Описание для пустого избранного",
  "Www.Settings.specialsDescription": "Описание для спецвыпусков",
  "Www.Settings.defaultImageId": "Картинка по умолчанию",
  "Www.Settings.finalSound": "Сообщение при завершении",
  "Www.Settings.playerSpeed": "Скорость воспроизведения плеера",
  // "Www.Settings.adContacts": "Контакты рекламодателя",
  "Www.Settings.tariffsTitle": "Заголовок для тарифов",
  "Www.Settings.tariffsText": "Текст для тарифов",
  "Www.Settings.tariffsPrices": "Текст для тарифов",
  "Www.Settings.regionSubtitle": "Подзаголовок для `Городские новости`",
  "Www.Settings.regionNotFound": "Подзаголовок для `Не нашли свой город`",
  "Www.Settings.messageChannelsUrls": "Сссылки на телеграм-каналы",

  "Www.Settings.tariffsBlock1": "Тарифы 1",
  "Www.Settings.tariffsBlock2": "Тарифы 2",
  "Www.Settings.aboutContacts": "Контакты сотрудничества",
  "Www.Settings.specialsBlock": "Блок `Спецпроекты`",
  "Www.Settings.subscribeBlock": "Блок `Подписаться`",
  "Www.Settings.liveStreamPage": "Страница `Трансляция`",
  "Www.Settings.liveStreamBlock": "Блок `Трансляция`",
  "Www.Settings.channelInfoBlock": "Блок `Канал в телеграм`",
  "Www.Settings.howItWorkBlock": "Блок `Как это работает`",
  "Www.Settings.joinChannelBlock": "Блок `Подключить канал`",
  "Www.Settings.onboardBlock": "Блок `Онбординг`",
  "Www.Settings.soundtrackFileId": "Фоновая музыка",
  "Www.Settings.backgroundSounds": "Фоновая музыка",
  "Www.Settings.jingleFileId": "Звук джингла",
  "Www.Settings.helpText": "Текст помощи пользователю",
  "Www.Settings.stopText": "Текст ошибки регистрации игрушки",
  "Www.Settings.shareScreenText": "Текст на экране `поделиться`",
  "Www.Settings.softToys": "Описания мягких игрушек",
  "Www.Settings.digitalToys": "Описания цифровых игрушек",

  "Www.Landing": "Лендинг",
  "Www.Landing.soundMessage": "Звуковое сообщение",
  "Www.Landing.intro": "Титульный блок",
  "Www.Landing.extra": "Дополнительный блок",
  "Www.Landing.block1": "Блок 1",
  "Www.Landing.block2": "Блок 2",
  "Www.Landing.block3": "Блок 3",
  "Www.Landing.block4": "Блок 4",
  "Www.Landing.block5": "Блок 5",
  "Www.Landing.block6": "Блок 6",
  "Www.Landing.block7": "Блок 7",
  "Www.Landing.block8": "Блок 8",

  "Www.Landing.title": "Название",
  "Www.Landing.content": "Содержание",
  "Www.Landing.isHtml": "HTML-контент",
  "Www.Landing.image": "Изображение",
  "Www.Landing.buttons": "Кнопки",

  "Www.Meta": "Мета-данные",
  "Www.Meta.sitename": "Название сайта",
  "Www.Meta.index": "Главная страница",
  "Www.Meta.account": "Аккаунт",
  "Www.Meta.ad": "Рекламодателям",
  "Www.Meta.channels": "Каналы",
  "Www.Meta.join": "Каналам",
  "Www.Meta.playlist": "Плейлист",
  "Www.Meta.about": "О проекте",
  "Www.Meta.live": "Трансляция",
  "Www.Meta.onboard": "Онбординг",
  "Www.Meta.favorites": "Избранное",
  "Www.Meta.specials": "Спецвыпуски",

  "Www.Meta.title": "Заголовок",
  "Www.Meta.description": "Описание",
  "Www.Meta.keywords": "Ключевые слова",
  "Www.Meta.image": "Изображение",

  "Www.Faq": "FAQ",
  "Www.Faq.Add": "Добавить вопрос",
  "Www.Faq.Form": "Редактировать вопрос",
  "Www.Faq.title": "Название",
  "Www.Faq.ident": "ident",
  "Www.Faq.type": "Тип",
  "Www.Faq.question": "Вопрос",
  "Www.Faq.answer": "Ответ",

  "Www.Contacts": "Контакты",
  "Www.Contacts.Add": "Добавить новый",
  "Www.Contacts.Form": "Редактировать",
  "Www.Contacts.title": "Заголовок",
  "Www.Contacts.url": "Ссылка",
  "Www.Contacts.image": "Изображение",

  "Www.Contents": "Контент",
  "Www.Contents.Add": "Добавить новый",
  "Www.Contents.Form": "Редактировать контент",
  "Www.Contents.title": "Заголовок",
  "Www.Contents.data": "Содержимое",
  "Www.Contents.image": "Изображение",
  "Www.Contents.url": "Ссылка",

  "Www.Feedbacks": "Обратная связь",
  "Www.Feedbacks.Add": "Добавить запись",
  "Www.Feedbacks.Form": "Редактировать запись",
  "Www.Feedbacks.realDate": "Реальная дата отзыва",
  "Www.Feedbacks.indexPage": "Показывать на главной",
  "Www.Feedbacks.localesName": "Автор",
  "Www.Feedbacks.localesText": "Отзыв",
  "Www.Feedbacks.images": "Изображения",
  "Www.Feedbacks.value": "Оценка",

  "soundMessage.button": "Кнопка",
  "soundMessage.title": "Заголовок",
  "soundMessage.content": "Текст",
  "soundMessage.mp3": "Mp3",
  "soundMessage.image": "Картинка",

  "contactsData.title": "Заголовок",
  "contactsData.content": "Текст",
  "contactsData.telegram": "Телеграм",
  "contactsData.email": "Email",
  "contactsData.image": "Картинка",

  "subscribeData.title": "Заголовок",
  "subscribeData.content": "Текст",
  "subscribeData.button": "Кнопка",
  "subscribeData.image": "Картинка",

  textSpeed: "Скорость речи, %",

  meta: "Мета аттрибуты",
  "meta.title": "Заголовок",
  "meta.description": "Описание",
  "meta.keywords": "Ключевые слова",
  "meta.image": "Изображение",
  error: "Ошибка",
  "error.auth-error": "Ошибка авторизации",
  confirmAction: "Подтвердите действие",
  ok: "Подтвердить",
  save: "Cохранить",
  saving: "Данные сохраняются",
  saved: "Данные сохранены",
  add: "Добавить",
  edit: "Редактировать",
  delete: "Удалить",
  remove: "Удалить",
  cancel: "Отмена",
  total: "Всего",
  logout: "Выйти",
  "not-found": "не найдено",
  loading: "Идет загрузка",
  noData: "Нет данных",
  "tables.title": "Название",
  // "tables.enabled": "Заблокировано",
  "tables.blocked_filter": "Заблокированные",
  "tables.enabled": "Активность",
  "tables.enabled.yes": "Активен",
  "tables.enabled.no": "Неактивен",
  "tables.status": "Статус",
  "tables.created": "Дата",
  "tables.updated": "Обновлено",
  dateFormat: "DD.MM.YYYY",
  timeFormat: "HH:mm:ss",
  dateTimeFormat: "DD.MM.YYYY HH:mm",
  "pager.limit": "Кол-во на странице",
  free: "Бесплатно",
  url: "Ссылка",
  hoursFrom: "С",
  hoursTill: "По",
  volume: "Громкость (1~100)",

  hours: "{value} ч.",
  minutes: "{value} мин.",
  seconds: "{value} сек.",

  //
  symbol: "Символ",
  name: "Название",
  localesName: "Локализация названия",
  localesDescription: "Локализация описания",
  value: "Значение",
  oldValue: "Старое значение",
  type: "Тип",
  description: "Описание",

  text: "Текст",
  file: "Файл",

  date: "Дата",
  minDate: "Начало периода",
  maxDate: "Конец периода",

  // типовые значения
  ok: "OK",
  confirm: "Подтвердить",
  yes: "Да",
  no: "Нет",
  close: "Закрыть",
  select_value: "Выберите значение",
  urlCopied: "Ссылка скопирована",
  download: "Скачать",
  time: "Время",
  number: "Номер",

  blocked_filter: "Показать/скрыть заблокированные",

  Special: "Служебные",
  "Special.Translates": "Переводы",
  "Special.Translates.Add": "Новая задача",
  "Special.Translates.referenceName": "Модель данных",
  "Special.Translates.sourceLocale": "Исходная локализация",
  "Special.Translates.targetLocale": "Целевая локализация",
  "Special.Translates.skipTranslated": "Пропускать уже переведенные",
  "Special.Translates.status": "Статус",
  "Special.Translates.symbolsCount": "Кол-во символов",
  "Special.Translates.detectedId": "Всего записей",
  "Special.Translates.completedId": "Завершено",
  "Special.Translates.skippedId": "Пропущено",
  "Special.Translates.errorId": "Ошибки",

  Auth: "Авторизация",
  "Auth.login": "Логин",
  "Auth.password": "Пароль",
  "Auth.doLogin": "Вход",
  "Auth.forgotPassword": "Забыли пароль?",
  "Auth.enterRestoreData": "Введите номер телефона, на который зарегистрирована учетная запись",
  "Auth.confirmCode": "Введите проверочный код",
  "Auth.doRequestCode": "Запросить проверочный код",
  "Auth.doConfirmCode": "Подтвердить код",
  "Auth.wrong-login": "Неверный логин",
  "Auth.wrong-code": "Неверный код",
  "Auth.wrong-user": "Недоступный пользователь",
  "Auth.wrong-password": "Неверный пароль",
  "Auth.wrong-data": "Неверные данные",
  "Auth.login-required": "Требуется ввести логин",
  "Auth.password-required": "Требуется ввести пароль",
  "Auth.back": "На страницу авторизации",
  "Auth.in-progress": "Авторизация в системе",

  "sidebar.demo": "Демо",
  "sidebar.demopage": "Демо страница",
  "sidebar.dashboard": "Сводка",
  "sidebar.pages": "Страницы",
  "sidebar.authentication": "Authentication",
  "sidebar.login": "Login",
  "sidebar.register": "Register",
  "sidebar.forgotpassword": "Forgot Password",
  "sidebar.userpages": "User Pages",
  "sidebar.lockscreen": "Lock Screen",
  "sidebar.timeline": "Timeline",
  "sidebar.userprofile": "User Profile",
  "sidebar.error": "Error",
  "sidebar.400": "400",
  "sidebar.forms": "Forms",
  "sidebar.regularforms": "Regular Forms",
  "sidebar.extendedforms": "Extended Forms",
  "sidebar.validationforms": "Validation Forms",
  "sidebar.wizard": "Wizard",
  "sidebar.chat": "Chat",
  "sidebar.select": "Select",
  "sidebar.selectcontrols": "Select Controls",
  "sidebar.googlemaps": "Google Maps",
  "sidebar.fullscreenmap": "Full Screen Map",
  "sidebar.vectormap": "Vector Map",
  "sidebar.tables": "Tables",
  "sidebar.regulartabels": "Regular Tables",
  "sidebar.extendedtables": "Extended Tables",
  "sidebar.reacttables": "React Table",
  "sidebar.components": "Components",
  "sidebar.buttons": "Buttons",
  "sidebar.custombuttons": "Custom Buttons",
  "sidebar.gridsystem": "Grid System",
  "sidebar.panels": "Panels",
  "sidebar.sweetalert": "Sweet Alert",
  "sidebar.notifications": "Notifications",
  "sidebar.icons": "Icons",
  "sidebar.typography": "Typography",
  "sidebar.widgets": "Widgets",
  "sidebar.charts": "Charts",
  "sidebar.calender": "Calender",
  "sidebar.gauges": "Gauges",
  "sidebar.datepicker": "DatePicker",
  "sidebar.reactstrapcomponents": "React Strap",
  "sidebar.alerts": "Alerts",
  "sidebar.badges": "Badges",
  "sidebar.breadcrumbs": "Breadcrumbs",
  "sidebar.buttondropdown": "Button Dropdown",
  "sidebar.buttongroup": "Button Group",
  "sidebar.card": "Card",
  "sidebar.carousel": "Carousel",
  "sidebar.collapse": "Collapse",
  "sidebar.dropdowns": "Dropdowns",
  "sidebar.fade": "Fade",
  "sidebar.form": "Form",
  "sidebar.maps": "Maps",
  "sidebar.tracking-vehicle": "Tracking Vehicle",
  "sidebar.inputgroup": "Input Group",
  "sidebar.jumbotron": "Jumbotron",
  "sidebar.layout": "Layout",
  "sidebar.listgroup": "ListGroup",
  "sidebar.media": "Media",
  "sidebar.modals": "Modals",
  "sidebar.navbar": "Navbar",
  "sidebar.nav": "Nav",
  "sidebar.pagination": "Pagination",
  "sidebar.popovers": "Popovers",
  "sidebar.progress": "Progress",
  "sidebar.tabs": "Tabs",
  "sidebar.tooltips": "Tooltips",
  "sidebar.app": "Приложение",
  "sidebar.userinterface": "User Interface",
  "sidebar.style&userinterface": "Style & User Interface",
  "sidebar.uicomponents": "Ui Components",
  "sidebar.others": "Others",
  "sidebar.menuexamples": "Examples",
  "sidebar.500": "500",
  "sidebar.single": "Single",
  "sidebar.onelevel": "One Level",
  "sidebar.secondlevel": "Second Level",
  "sidebar.example": "Example",
  "sidebar.example1": "Example 1",
  "sidebar.example2": "Example 2",
  "sidebar.colors": "Colors",
  "sidebar.pricing": "Pricing",
  "sidebar.style1": "Style 1",
  "sidebar.style2": "Style 2",
  "sidebar.contact": "Contact",
  "sidebar.themes": "Themes",
  "sidebar.basicelement1": "Basic Element 1",
  "sidebar.basicelement2": "Basic Element 2",
  "sidebar.advanceelement": "Advance Element",
  "sidebar.pricingpages": "Pricing Pages",
  "sidebar.errorpages": "Error Pages",
  "sidebar.scrumboard": "Scrumboard",
  "sidebar.editors": "Editors",
  "sidebar.roeeditor": "Roe Editor",
  "sidebar.roemarkupeditor": "Roe Markup Editor",
  "sidebar.wysiwygeditor": "Wysiwyg Editor",
  "sidebar.quill": "Quill",
  "sidebar.quilleditor": "Quill Editor",
  "sidebar.foreditor": "For Editor",
  "sidebar.socialwidgets": "Social Widgets",
  "sidebar.chartwidgets": "Chart Widgets",
  "sidebar.blogwidgets": "Blog Widgets",
  "sidebar.statisticswidgets": "Statistics Widgets",
  "sidebar.filemanager": "File Manager",
  "sidebar.todos": "Todos",
  "themeChanger.settings": "Settings",
  "themeChanger.sidebar": "Sidebar Varients",
  "themeChanger.footer": "Footer",
  "themeChanger.background": "Background",
  "themeChanger.topbar": "Topbar",
  "themeSetting.layouts": "Layouts",
  "themeSetting.vertical": "Vertical",
  "themeSetting.horizontal": "Horizontal",
  "themeSetting.themebuilder": "Theme Builder",
  "themeSetting.alignments": "Alignments",
  "themeSetting.topbar": "Topbar",
  "themeSetting.footer": "Footer",
  "themeSetting.display": "Display",
  "themeSetting.below": "Below",
  "themeSetting.above": "Above",
  "themeSetting.show": "Show",
  "themeSetting.hide": "Hide",
  "themeSetting.on": "On",
  "themeSetting.off": "Off",
  "themeSetting.tranperentmod": "Transperent Mode",
  "themeSetting.sidebartransparent": "Sidebar Transparent",
  "themeSetting.activepanel": "Sidebar Variant",
  "themeSetting.style1": "style1",
  "themeSetting.style2": "style2",
  "themeSetting.style3": "style3",
  "themeSetting.style4": "style4",
  "themeSetting.colorSchema": "Sidebar Scheme",
  "themeSetting.sidebarmini": "Sidebar Mini",
  "themeSetting.gradients": "Gradients",
  "languageSwitcher.label": "Language",
  "header.editprofile": "Edit Profile",
  "header.settings": "Settings",
  "header.inbox": "Inbox",
  "header.signout": "Signout",
};
